"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentLockStatus;
(function (ContentLockStatus) {
    ContentLockStatus["LOCKED"] = "locked";
    ContentLockStatus["UNLOCKED"] = "unlocked";
    ContentLockStatus["NO_LOCK"] = "noLock";
})(ContentLockStatus = exports.ContentLockStatus || (exports.ContentLockStatus = {}));
exports.typeList = ['article', 'podcast', 'video', 'download'];
var CategorySlugs;
(function (CategorySlugs) {
    CategorySlugs["ALL"] = "all";
    CategorySlugs["PROFESSIONAL_INSIGHTS"] = "professional-insights";
    CategorySlugs["NEWS"] = "news";
    CategorySlugs["RESOURCES"] = "resources";
    CategorySlugs["CPE_LEARNING"] = "cpe-learning";
    CategorySlugs["ABOUT"] = "about";
    CategorySlugs["HELP"] = "help";
    CategorySlugs["DONATIONS"] = "donations";
    CategorySlugs["LOCATION"] = "location";
    CategorySlugs["MEMBERSHIP"] = "membership";
    CategorySlugs["ADVOCACY"] = "advocacy";
    CategorySlugs["CERTIFICATIONS"] = "certifications";
    CategorySlugs["CPD_LEARNING"] = "cpd-and-learning";
})(CategorySlugs = exports.CategorySlugs || (exports.CategorySlugs = {}));
exports.BlogContentSource = 'AICPA & CIMA Insights Blog';
var NewsSubmenuItems;
(function (NewsSubmenuItems) {
    NewsSubmenuItems["PUBLICATIONS"] = "Publications";
})(NewsSubmenuItems = exports.NewsSubmenuItems || (exports.NewsSubmenuItems = {}));
var ContentType;
(function (ContentType) {
    ContentType["MEGAMENU_LIST"] = "megamenuList";
    ContentType["DYNAMIC_LIST"] = "dynamicList";
    ContentType["LISTS"] = "lists";
    ContentType["LIST_BLOCK"] = "blockList";
    ContentType["PROMOTIONAL_COMPONENT"] = "promotionalComponent";
    ContentType["PRODUCT_TYPE"] = "productType";
    ContentType["SUBMENU"] = "megamenuLevel1Submenu";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var ListsType;
(function (ListsType) {
    ListsType["PROMOTED_PRODUCTS"] = "megamenuLevel2PromotedProducts";
})(ListsType = exports.ListsType || (exports.ListsType = {}));
var DisplayType;
(function (DisplayType) {
    DisplayType["IMAGE"] = "Image";
    DisplayType["TEXT"] = "Text";
})(DisplayType = exports.DisplayType || (exports.DisplayType = {}));
var Level;
(function (Level) {
    Level["LEVEL0"] = "level0";
    Level["LEVEL1"] = "level1";
})(Level = exports.Level || (exports.Level = {}));
var SortBy;
(function (SortBy) {
    SortBy["MOST_RECENT"] = "Most Recent";
    SortBy["MOST_RELEVANT"] = "Most Relevant";
})(SortBy = exports.SortBy || (exports.SortBy = {}));
//# sourceMappingURL=index.js.map